<template>
  <el-dialog
    :title="`充值余额 - ${currentUser ? currentUser.nickname || currentUser.mobile : ''}`"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="balanceForm"
      :model="form"
      :rules="rules"
      label-width="100px"
      class="balance-form"
    >
      <el-form-item label="当前余额">
        <el-input v-model="currentBalance" disabled>
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <el-form-item label="充值金额" prop="balance">
        <el-input
          v-model="form.balance"
          type="number"
          placeholder="请输入充值金额"
          :min="0.01"
          :step="0.01"
          :precision="2"
          @input="handleBalanceInput"
        >
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <el-form-item label="充值原因" prop="reason">
        <el-input
          v-model="form.reason"
          type="textarea"
          :rows="3"
          placeholder="请输入充值原因（1-200字符）"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button
        type="primary"
        :loading="submitting"
        @click="handleSubmit"
      >确认充值</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addBalances } from '@/api/user'

export default {
  name: 'AddBalanceDialog',
  data() {
    return {
      dialogVisible: false,
      currentUser: null,
      currentBalance: '0.00',
      form: {
        user_id: 0,
        balance: '',
        reason: ''
      },
      rules: {
        balance: [
          { required: true, message: '请输入充值金额', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!value || parseFloat(value) <= 0) {
                callback(new Error('充值金额必须大于0'))
              } else if (parseFloat(value) > 999999) {
                callback(new Error('充值金额不能超过999999元'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        reason: [
          { required: true, message: '请输入充值原因', trigger: 'blur' },
          { min: 1, max: 200, message: '充值原因长度为1-200字符', trigger: 'blur' }
        ]
      },
      submitting: false
    }
  },
  methods: {
    // 打开对话框
    open(user) {
      this.currentUser = user
      this.form.user_id = user.id
      this.form.balance = ''
      this.form.reason = ''
      this.currentBalance = Number(user.balance || 0).toFixed(2)
      this.dialogVisible = true

      // 重置表单验证
      this.$nextTick(() => {
        if (this.$refs.balanceForm) {
          this.$refs.balanceForm.clearValidate()
        }
      })
    },

    // 关闭对话框
    handleClose() {
      this.dialogVisible = false
    },

    // 金额输入处理
    handleBalanceInput(value) {
      // 限制为正数，最多2位小数
      const regex = /^\d+(\.\d{0,2})?$/
      if (!regex.test(value)) {
        this.$nextTick(() => {
          this.form.balance = value.replace(/[^\d.]/g, '').replace(/^(\d+\.\d{2}).+$/, '$1')
        })
      }
    },

    // 提交充值
    async handleSubmit() {
      // 表单验证
      this.$refs.balanceForm.validate(async (valid) => {
        if (!valid) return

        // 确认提示
        const balanceValue = parseFloat(this.form.balance).toFixed(2)
        this.$confirm(
          `确认给用户「${this.currentUser.nickname || this.currentUser.mobile}」充值${balanceValue}元？`,
          '充值确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(async () => {
          this.submitting = true
          try {
            const res = await addBalances({
              user_id: this.form.user_id,
              balance: parseFloat(this.form.balance),
              reason: this.form.reason
            })

            if (res.code === 200) {
              this.$message.success('充值成功')
              this.dialogVisible = false
              this.$emit('refresh')
            } else {
              this.$message.error(res.msg || res.message || '充值失败')
            }
          } catch (error) {
            console.error('充值失败', error)
            this.$message.error(error.message || '网络错误，请重试')
          } finally {
            this.submitting = false
          }
        }).catch(() => {})
      })
    }
  }
}
</script>

<style scoped>
.balance-form {
  padding: 0 20px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* 充值金额输入框样式 */
.balance-form :deep(.el-input__inner) {
  text-align: right;
  padding-right: 40px;
}

.balance-form :deep(.el-input-group__append) {
  padding: 0 12px;
  background-color: #f5f7fa;
  border-left: 1px solid #dcdfe6;
  color: #909399;
}

/* 当前余额输入框样式 */
.balance-form :deep(.el-input.is-disabled .el-input__inner) {
  background-color: #f5f7fa;
  color: #606266;
}
</style>
